import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 16px;
  width: 100%;
  background: #ffffff;
  color: var(--button-secondary-main);
  border: 1px solid var(--button-secondary-main);
  border-radius: 4px;

  @media (min-width: 640px) {
    width: 150px;
  }

  &:hover {
    background-color: var(--button-secondary-hover);
  }
  &:focus {
    background-color: var(--button-secondary-focus);
  }
  &:active {
    background-color: var(--button-secondary-focus|);
  }
`;

interface ButtonAnnulProps extends React.ComponentPropsWithoutRef<'button'> {
  onClick: (e: any) => void;
  buttonText?: string;
}

const ButtonAnnul = ({ onClick, buttonText, ...props }: ButtonAnnulProps) => (
  <Button
    data-testid="cmp-button-annul"
    className="fadeTransition"
    onClick={onClick}
    {...props}
  >
    <span>{buttonText}</span>
  </Button>
);

ButtonAnnul.defaultProps = {
  buttonText: 'Anular inscripción'
};

export default ButtonAnnul;
